import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProductDetails } from '@synergy/components';
import { Theme } from '@mui/material';
import { WithStyles, createStyles, withStyles } from '@mui/styles';

import { OfferItem } from '../../../../../common/models/offer-item';

const styles = (theme: Theme) =>
    createStyles({
        container: {
            padding: theme.spacing(3),
        },
        position: {
            fontSize: '12px',
            lineHeight: '14px',
            color: '#21272E',
            display: 'block',
            opacity: 0.8,
        },
        articleCount: {
            fontSize: '13px',
            lineHeight: '16px',
            color: '#21272E',
            display: 'block',
            opacity: 0.5,
        },
        description: {
            marginBottom: theme.spacing(),
        },
    });

interface PriceMatrixPositionProps extends WithStyles<typeof styles> {
    position: number;
    offerItem: OfferItem;
}

export const PriceMatrixPosition = withStyles(styles)(
    class PriceMatrixPositionBase extends Component<PriceMatrixPositionProps> {
        public render() {
            const { classes, position, offerItem } = this.props;
            const description = offerItem.getDescription();

            return (
                <div className={classes.container}>
                    <span className={classes.position}>
                        <FormattedMessage id="app.priceMatrix.positionNumber" /> {position}
                    </span>
                    {description && <ProductDetails product={offerItem} sx={{ pt: 1.25 }} />}
                    <div className={classes.articleCount}>
                        {offerItem.quantity} {offerItem.orderUnit}
                        {offerItem.contentQuantity && (
                            <span>
                                {' '}
                                ({offerItem.contentQuantity} {offerItem.contentUnit} / {offerItem.orderUnit})
                            </span>
                        )}
                    </div>
                </div>
            );
        }
    }
);
